import { css } from '@/styled-system/css';

export const alertActionRecipe = css.raw({
  marginBlockStart: 'Alert.gap.content-toActions',
});
